import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PetOverview } from '@/pet/src/components/PetOverview';
import { NoPetsEmptyState } from '@/pet/src/components/NoPetsEmptyState';
import { OwnerOnboardingBanner } from '@/pet/src/components/owner/OwnerOnboardingBanner';
import { usePets } from '@/pet/src/context/PetsContext';
import { useOwnerOnboarding } from '@/pet/src/context/OwnerOnboardingContext';

export const Route = createFileRoute('/dashboard/')({
  component: PetsoOverview,
});

function PetsoOverview() {
  const navigate = useNavigate();
  const { selectedPet, isLoading } = usePets();
  const { isOnboardingComplete } = useOwnerOnboarding();

  const handleNavigateToSettings = () => {
    navigate({ to: '/dashboard/settings' });
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!selectedPet) {
    return (
      <>
        {!isOnboardingComplete && (
          <OwnerOnboardingBanner onNavigateToSettings={handleNavigateToSettings} />
        )}

        <NoPetsEmptyState />
      </>
    );
  }

  return (
    <>
      {!isOnboardingComplete && (
        <OwnerOnboardingBanner onNavigateToSettings={handleNavigateToSettings} />
      )}
      <PetOverview pet={selectedPet} isOnboardingComplete={isOnboardingComplete} />
    </>
  );
}
